<template>
  <div class="form-group mt-5" :class="{ hasValue: showInput }">
    <div :class="{ invalid: isInvalid() }">
      <input
        :readonly="config.readonly"
        ref="item"
        :type="config.InputType"
        :name="id"
        :data-vv-as="config.ErrorMessage"
        v-validate="'email'"
        :id="'input' + id"
        class="form-control"
        :value="value"
        :required="config.Validation.required"
        @input="update()"
        @change="doChange()"
        @blur="update()"
      />
    </div>
    <label class="form-control-placeholder" :for="id">
      <span v-if="!config.UseAlternative">{{ config.Placeholder }}</span>
      <span v-if="config.UseAlternative">{{
        config.AlternativePlaceholder
      }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
    </label>
    <InfoText
      v-if="config.Info && showinfo()"
      :content="config.Info"
      :id="id"
    />
    <div class="invalid-mandatory" ref="error" v-if="isInvalid()">
      {{ errors.first(id) }}
    </div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';

  export default {
    components: { InfoText },
    props: ['value', 'id', 'config'],
    inject: {
      $validator: '$validator',
    },
    data() {
      return {
        showInput: false,
        innerValue: 0,
      };
    },
    watch: {
      value: function (newVal) {
        // watch it
        if (newVal) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
      },
    },
    methods: {
      update() {
        // check if valid
        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
        this.innerValue = this.$refs.item.value;
        this.$emit('input', this.$refs.item.value);
      },
      doChange() {
        this.$emit('getNewData');
      },
      showinfo() {
        if (
          this.config.NoInfoFor &&
          this.config.NoInfoFor.employment !== this.$store.state.employment
        ) {
          return true;
        }
        return false;
      },
      isInvalid() {
        return (
          this.$store.state.componentIsInvalid &&
          this.config.Validation.required &&
          this.errors.first(this.id)
        );
      },
    },
    mounted() {
      if (this.value) {
        this.showInput = true;
      } else {
        this.showInput = false;
      }
    },
  };
</script>
